import { useEffect, useState } from "react";
import { Save, X, Loader2 } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { apiFetch, apiFetch_ } from "../apiFetch";
import ProgramExplorer from "../components/ProgramExplorer";
import keycloak from "../keycloak";
import { formatPeriodName } from "../utils";

export default function ProgramCreatePage() {
  const [programName, setProgramName] = useState("");
  const [programsWithConfig, setProgramsWithConfigs] = useState([]);
  const [program, setProgram] = useState(null);
  const [loading, setLoading] = useState(false);
  const [organizations, setOrganizations] = useState([])
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  /**
   * ============================================================
   * INITIAL PAGE LOAD
   * ============================================================
   *
   * If URL contains:
   *
   * /program/create?id=<payment_process_id>
   *
   * then automatically:
   *
   * 1. Fetch payment process
   * 2. Find matching program by refrenceId
   * 3. Create program if it doesn't exist
   * 4. Navigate to config page
   */
  useEffect(() => {
    const id = searchParams.get("id");

    console.log("Page loaded, payment process id:", id);

    if (id) {
      fetchOrganizationDetails();
    }
  }, [searchParams]);

  useEffect(() => {

    const id = searchParams.get("id");
    console.log("Ogranization fetched ", organizations?.length);

    if (organizations && organizations.length>0) {
      checkAndCreateProgram(id,organizations[0]);
    }
  }, [organizations]);

  /**
   * ============================================================
   * GET ORGANIZATION DETAILS
   * ============================================================
   */
  async function fetchOrganizationDetails(paymentProcessId) {
    const response = await apiFetch_(
      `${process.env.REACT_APP_PAYPROMPT_URL}user/api/v1/organization/organization/?skip_user_permission=true&page=1&page_size=100`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(
        `Payment process API failed with status ${response.status}`
      );
    }
    let orgsResponse   = await response.json();
    if(orgsResponse && orgsResponse.results){
      setOrganizations(orgsResponse.results);
    }
   
  }



  /**
   * ============================================================
   * CHECK PAYMENT PROCESS -> PROGRAM
   * ============================================================
   */
  async function checkAndCreateProgram(paymentProcessId,organization) {
    try {
      setLoading(true);
      /**
       * --------------------------------------------------------
       * STEP 1: Fetch Payment Process Details
       * --------------------------------------------------------
       */
      const paymentResponse = await fetchPaymentProcessDetails(paymentProcessId);
      const paymentProcess = paymentResponse?.results;
     
      if (!paymentProcess) {
        throw new Error("Payment process details not found");
      }

      const iprogramId = paymentProcess.iprogram_id;
      const iprogramName = paymentProcess.iprogram_name;

      console.log("iProgram ID:", iprogramId);
      console.log("iProgram Name:", iprogramName);

      if (!iprogramId) {
        throw new Error("iprogram_id is missing from payment process");
      }

      /**
       * --------------------------------------------------------
       * STEP 2: Fetch Existing Programs
       * --------------------------------------------------------
       */
      const programsResponse = await apiFetch("program/configs", {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!programsResponse.ok) {
        throw new Error("Failed to fetch programs");
      }

      const programs = await programsResponse.json();

      console.log("Existing programs:", programs);

      /**
       * --------------------------------------------------------
       * STEP 3: Find Program Using refrenceId
       * --------------------------------------------------------
       *
       * Payment API:
       *
       * iprogram_id:
       * 06a45149-6ac6-7ee0-8000-3faa0eb65787
       *
       * Existing Program:
       *
       * refrenceId:
       * 06a45149-6ac6-7ee0-8000-3faa0eb65787
       */
      const existingProgram = programs?.find(
        (item) =>
          item.refrenceId &&
          String(item.refrenceId).toLowerCase() ===
            String(iprogramId).toLowerCase()
      );

      /**
       * --------------------------------------------------------
       * STEP 4: PROGRAM EXISTS
       * --------------------------------------------------------
       */
      if (existingProgram) {
        console.log("Matching program found:",existingProgram);

        setProgram(existingProgram);

        /**
         * SET THE ORGANIZATION
         */
        paymentProcess.programId  = existingProgram.id;
        paymentProcess.organization_id = organization?.unique_id;
        paymentProcess.organization_name = organization?.organization_name;

        /**
         *  STEP 4.1 : CHECK CONFIG EXIST OR NOT
         */
        const frequencyType = paymentProcess?.frequency_type;
        const frequencyValue = paymentProcess?.frequency_value;
        const generatedConfigName = formatPeriodName(frequencyType, frequencyValue);
        
        const existingConfig = existingProgram?.configs?.find(
        (item) =>
          item?.configName &&
          String(item?.configName).toLowerCase() === String(generatedConfigName).toLowerCase()
        );

       /**
        * IF CONFIG EXIST THEN MOVE TO EDIT AND RUN PAGE
        */
       if(existingConfig){
          console.log("Matching program config found:",existingConfig);
          if(existingConfig?.uploadedFiles && existingConfig?.uploadedFiles?.length>0){

          }else{
             
          }
          navigate(`/programs/configs/${existingProgram.id}`,{
                      state: {
                        program:existingProgram,
                        config:existingConfig,
                        paymentProcess: paymentProcess,
                      },
                     
                                            
              })
              return;
       }
        /**
         * Navigate directly to config page
         */
        navigate(`/programs/config/${existingProgram.id}`, {
          replace: true,
          state: {
            program: existingProgram,
            paymentProcess: paymentProcess,
          },
        });

        return;
      }

      /**
       * --------------------------------------------------------
       * STEP 5: PROGRAM DOES NOT EXIST
       * --------------------------------------------------------
       */
      console.log(
        "No matching program found. Creating new program..."
      );

      const createResponse = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}program`,
        {
          programName: iprogramName,
          createdBy:
            paymentProcess.updated_by_user || paymentProcess.initiated_by ||  keycloak.tokenParsed?.name || keycloak.tokenParsed?.preferred_username,
            organizationId: 1,

          /**
           * IMPORTANT:
           * Store the external iProgram ID here.
           */
          refrenceId: iprogramId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const newProgram = createResponse.data;

      console.log("Program created:", newProgram);

      setProgram(newProgram);

      /**
       * --------------------------------------------------------
       * STEP 6: Navigate to Config Page
       * --------------------------------------------------------
       */
      paymentProcess.programId  = newProgram.id;
      paymentProcess.organization_id = organization?.unique_id;
      paymentProcess.organization_name = organization?.organization_name;
      navigate(`/programs/config/${newProgram.id}`, {
        replace: true,
        state: {
          program: newProgram,
          paymentProcess: paymentProcess,
        },
      });
    } catch (error) {
      console.error(
        "checkAndCreateProgram error:",
        error
      );

      alert(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to load or create program"
      );
    } finally {
      setLoading(false);
    }
  }

  /**
   * ============================================================
   * FETCH PAYMENT PROCESS
   * ============================================================
   */
  async function fetchPaymentProcessDetails(paymentProcessId) {
    const response = await apiFetch_(
      `${process.env.REACT_APP_PAYPROMPT_URL}app/api/v1/payment_management/payment_process/${paymentProcessId}/`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "skip-permission":
            process.env.REACT_APP_SKIP_PERMISSION,
        },
      }
    );

    if (!response.ok) {
      throw new Error(
        `Payment process API failed with status ${response.status}`
      );
    }

    return await response.json();
  }


  /**
   * ============================================================
   * MANUAL CREATE PROGRAM
   * ============================================================
   */
  const handleCreateProgram = async () => {
    if (!programName.trim()) {
      alert("Program name is required");
      return;
    }

    try {
      setLoading(true);

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}program`,
        {
          programName,
          createdBy:  keycloak.tokenParsed?.name || keycloak.tokenParsed?.preferred_username,
          organizationId: 1,
          refrenceId: null,
        }
      );

      console.log("Program created:", response.data);

      setProgram(response.data);
      setProgramName("");

      await getProgramsWithConfigs();

      navigate(`/programs/config/${response.data.id}`, {
        replace: true,
        state: {
          program: response.data,
        },
      });
    } catch (error) {
      console.error(error);

      alert(
        error.response?.data?.message ||
          "Failed to create program"
      );
    } finally {
      setLoading(false);
    }
  };

  /**
   * ============================================================
   * FETCH PROGRAMS
   * ============================================================
   */
  async function getProgramsWithConfigs() {
    try {
      const response = await apiFetch("program/configs", {
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      setProgramsWithConfigs(data);

      return data;
    } catch (error) {
      console.error(
        "Failed to fetch programs:",
        error
      );

      throw error;
    }
  }

  /**
   * ============================================================
   * INITIAL PROGRAM LIST
   * ============================================================
   */
  useEffect(() => {
    /**
     * Only load the list when this is a normal
     * manual program creation page.
     *
     * If `id` exists, checkAndCreateProgram handles
     * everything.
     */
    const id = searchParams.get("id");

    if (!id) {
      getProgramsWithConfigs();
    }
  }, [searchParams]);

  /**
   * ============================================================
   * LOADING SCREEN
   * ============================================================
   */
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center font-display">
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm px-10 py-8 flex flex-col items-center gap-4">
          <Loader2
            size={38}
            className="animate-spin text-primary"
          />

          <div className="text-center">
            <h2 className="text-lg font-bold text-slate-900">
              Preparing Reconciliation Program
            </h2>

            <p className="mt-1 text-sm text-slate-500">
              Checking program configuration...
            </p>
          </div>
        </div>
      </div>
    );
  }

  /**
   * ============================================================
   * NORMAL MANUAL CREATE PAGE
   * ============================================================
   */
  return (
    <div className="bg-gray-50 min-h-screen p-6 font-display text-slate-900 flex flex-col">
      <main className="flex-1 px-6 md:px-10 py-8 max-w-[1440px] mx-auto w-full">

        {/* Header */}
        <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm mb-6 flex items-center justify-between">
          <div>
            <div className="text-xs font-black tracking-[0.3em] text-slate-400 uppercase">
              Reconciliation Program
            </div>

            <h1 className="mt-2 text-2xl font-black text-slate-900">
              Create Program
            </h1>

            <p className="mt-2 text-slate-500">
              Organize multiple reconciliation configurations
              into a single program.
            </p>
          </div>
        </div>

        {/* Create Program Card */}
        <div className="bg-white rounded-2xl border shadow-sm overflow-hidden">

          <div className="p-8">
            <label className="block text-sm font-semibold text-slate-700 mb-2">
              Program Name
            </label>

            <input
              type="text"
              value={programName}
              onChange={(e) =>
                setProgramName(e.target.value)
              }
              placeholder="Example: FY2026 Payment Reconciliation"
              className="
                w-full
                rounded-xl
                border
                border-slate-300
                px-4
                py-3
                focus:outline-none
                focus:ring-2
                focus:ring-primary
              "
            />
          </div>

          <div className="border-t bg-slate-50 px-6 py-4 flex justify-end gap-3">

            <button
              onClick={() => navigate(-1)}
              className="
                flex
                items-center
                gap-2
                px-5
                py-2
                rounded-lg
                border
                hover:bg-white
                transition
              "
            >
              <X size={18} />
              Cancel
            </button>

            <button
              onClick={handleCreateProgram}
              disabled={loading}
              className="
                flex
                items-center
                gap-2
                px-6
                py-2
                rounded-lg
                bg-primary
                text-white
                hover:bg-primary/90
                disabled:opacity-50
              "
            >
              <Save size={18} />

              {loading
                ? "Creating..."
                : "Create Program"}
            </button>
          </div>
        </div>

        {/* Program Explorer */}
        <div className="mt-6">
          <ProgramExplorer
            programs={programsWithConfig}
          />
        </div>
      </main>
    </div>
  );
}